<div ngSwitch="{{ type }}">
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'flat'"
		[type]="buttonType"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, 'static-w': sw }"
		mat-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="24" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'flat-icon'"
		[type]="buttonType"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading }"
		mat-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<span
			style="
				padding-left: 10px;
				display: inline-block;
				vertical-align: top;
			"
			class="icon-external-link"
		></span>
		<mat-spinner [diameter]="24" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'primary'"
		[type]="buttonType"
		color="primary"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, 'static-w': sw }"
		mat-raised-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'analysis'"
		[type]="buttonType"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, 'static-w': sw }"
		mat-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-icon class="jep-btn__icon material-symbols-outlined" aria-hidden="true"
			>arrow_forward</mat-icon
		>
		<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'secondary'"
		[type]="buttonType"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, 'static-w': sw }"
		mat-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'raised'"
		[type]="buttonType"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, 'static-w': sw }"
		mat-raised-button
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'icon-button-raised'"
		[type]="buttonType"
		mat-icon-button
		id="jep-icon-button"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading }"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
		style="background-color: #651fff !important"
	>
		<mat-icon class="{{ icon }}" style="color: #ffff"></mat-icon>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'icon-button'"
		[type]="buttonType"
		mat-icon-button
		id="jep-icon-button"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, custom: customClass }"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<ng-container *ngIf="isBadgeEnabled">
			<mat-icon *ngIf="useMaterialIcon"
				[matBadge]="badgeCount"
				[matBadgeHidden]="badgeCount === 0"
				matBadgeOverlap="true"
				matBadgeSize="small"
			>{{ icon }}</mat-icon>
			<span *ngIf="!useMaterialIcon"
				[matBadge]="badgeCount"
				[matBadgeHidden]="badgeCount === 0"
				matBadgeOverlap="true"
				matBadgeSize="small"
				[class]="icon"
			></span>
		</ng-container>
		<ng-container *ngIf="!isBadgeEnabled">
			<mat-icon *ngIf="useMaterialIcon">{{ icon }}</mat-icon>
			<span *ngIf="!useMaterialIcon" [class]="icon"></span>
		</ng-container>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'icon-badge-button'"
		[type]="buttonType"
		mat-icon-button
		[color]="color"
		class="jep-btn no-highlight"
		[ngClass]="{ loading: isLoading, disabled: isDisabled }"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<mat-icon>
			<span
				data-test="badge-icon-count"
				class="{{ icon }}"
				[ngClass]="{ light: light }"
				*ngIf="isBadgeEnabled"
				[matBadge]="badgeCount"
				[matBadgeHidden]="badgeCount === 0"
				matBadgeOverlap="false"
				matBadgeSize="small"
			></span>
			<span
				data-test="no-badge"
				class="{{ icon }}"
				[ngClass]="{ light: light }"
				*ngIf="!isBadgeEnabled"
			></span>
			<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
		</mat-icon>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'icon-menu'"
		[type]="buttonType"
		mat-icon-button
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading, disabled: isDisabled }"
		[disabled]="isDisabled"
		[matMenuTriggerFor]="menu"
	>
		<ng-container *ngIf="useMaterialIcon">
			<mat-icon>{{ icon }}</mat-icon>
		</ng-container>
		<ng-container *ngIf="!useMaterialIcon">
			<span [class]="icon"></span>
		</ng-container>
		<mat-menu #menu="matMenu">
			<button
				mat-menu-item
				(click)="select(menu)"
				*ngFor="let menu of menuItems; let i = index"
				[attr.data-testid]="testId ? testId + '-menu-item-' + i : null"
			>
				<span>{{ menu.name }}</span>
			</button>
			<!-- <button mat-menu-item disabled>
                  <span>Check voice mail</span>
                </button> -->
		</mat-menu>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'fab'"
		mat-fab
		[type]="buttonType"
		[color]="color"
		class="jep-btn"
		[ngClass]="{ loading: isLoading }"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="24" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchCase="'mini-fab'"
		mat-mini-fab
		[type]="buttonType"
		[color]="color"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<mat-icon [attr.aria-label]="icon || 'icon'">{{ icon }}</mat-icon>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		[style.width]="width"
		*ngSwitchCase="'outline'"
		[color]="color"
		class="jep-btn"
		mat-button
		[type]="buttonType"
		[ngClass]="{ loading: isLoading }"
		(click)="onClickButton($event)"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="20" class="jep-btn__loader"></mat-spinner>
	</button>
	<button
		#button
		[attr.data-testid]="testId"
		*ngSwitchDefault
		mat-button
		(click)="onClickButton($event)"
		[color]="color"
		class="jep-btn"
		[type]="buttonType"
		[ngClass]="{ loading: isLoading }"
		[disabled]="isDisabled"
	>
		<span class="jep-btn__text btn-text">{{ text }}</span>
		<mat-spinner [diameter]="24" class="jep-btn__loader"></mat-spinner>
	</button>
</div> 